module.exports = __webpack_public_path__ + "static/media/bg.89186f77.mp4";